import { getSafeLinkHref } from "@kushya/shared";

export interface ResolvedMarkdownLink {
  href: string | null;
  openInNewTab: boolean;
}

const isHttpLink = (href: string): boolean =>
  href.startsWith("http://") || href.startsWith("https://");

export const resolveMarkdownLink = (href: unknown): ResolvedMarkdownLink => {
  const safeHref = getSafeLinkHref(href);

  if (!safeHref) {
    return {
      href: null,
      openInNewTab: false,
    };
  }

  return {
    href: safeHref,
    openInNewTab: isHttpLink(safeHref),
  };
};
